import { Injectable } from '@angular/core';

import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { DatabaseReference, DatabaseSnapshot, Query } from 'angularfire2/database/interfaces';

import { storage } from 'firebase/app';

import { User } from '../models/user';

@Injectable()
export class UserService {

  private databaseReference: DatabaseReference;
  private storageReference: storage.Reference;

  constructor(
    private afAuth: AngularFireAuth,
    private afDatabase: AngularFireDatabase
  ) {
    this.databaseReference = afDatabase.database.ref('users');
    this.storageReference = storage().ref('users');
  }

  getUsers(query?: Query): FirebaseListObservable<User[]> {
    return this.afDatabase.list(this.databaseReference, { preserveSnapshot: true, query: query })
      .map((usersSnapshot: DatabaseSnapshot) => {
        const users: User[] = [];

        usersSnapshot.forEach(userSnapshot => {
          const user = User.fromDatabaseSnapshot(userSnapshot);

          if (user) {
            users.push(user);
          }

          return false;
        });

        return users;
      }) as FirebaseListObservable<User[]>;
  }

  getCurrentUser(): FirebaseObjectObservable<User | null> | null {
    if (this.afAuth.auth.currentUser) {
      return this.getUser(this.afAuth.auth.currentUser.uid);
    }

    return null;
  }

  async getProfileImageURLOfUser(user: User): Promise<URL | null> {
    try {
      const urlString: string = await this.storageReference
        .child(user.id)
        .child('profile.jpg')
        .getDownloadURL();
      return new URL(urlString);
    } catch (error) {
      if (error.code !== 'storage/object-not-found') {
        throw error;
      }

      return null;
    }
  }

  getUser(id: string): FirebaseObjectObservable<User | null> {
    const databaseReference = this.databaseReference.child(id);
    return this.afDatabase.object(databaseReference, { preserveSnapshot: true }).first()
      .map((userSnapshot: DatabaseSnapshot) =>
        User.fromDatabaseSnapshot(userSnapshot)
      ) as FirebaseObjectObservable<User | null>;
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/services/user.service.ts